import EdoPerformanceCapitalCalls from "./EdoPerformanceCapitalCalls";

export default EdoPerformanceCapitalCalls;
